export const getActionLabelsList = (arr) => {
  let actionLabelsArr = [];
  if (arr?.length) {
    arr?.forEach((element) => {
      actionLabelsArr?.push(element?.action_label);
    });
  }
  const uniqueActionLabelsSet = new Set([...actionLabelsArr]);
  const uniqueActionLabelsList = Array.from(uniqueActionLabelsSet);

  return uniqueActionLabelsList;
};

export default getActionLabelsList;
